import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState } from './config';


const EditInventoryItem = ({dialog = false, ignore_id = false}) => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"Inventory Item"} initialValues={initialValues} additionalState={additionalState} fields={formFields} schema={schema} url={"inventory_items"} dialog={dialog} redirect={dialog ? null : `/settings/inventory/items`} ignore_id={ignore_id}>
      
     </EditForm>
  );
}

export default EditInventoryItem;